import { initDependencies, setupDependencies } from './app';
import { runAppV2 } from './services/v2/runApp';

setupDependencies();

initDependencies();

runAppV2();

// eslint-disable-next-line @typescript-eslint/no-explicit-any
if ((module as any).hot) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (module as any).hot.accept();
}
